export default __webpack_public_path__ + "static/media/announce_bell.e867b889.svg";